import './MultipleEditDrawerContentTable.scss';

import React from 'react';
import type { Column, IdType, TableState } from 'react-table';

import CommonTable from '../../../../../../common/Table/Table';
import bem from '../../../../../../utils/bem';

const [block] = bem('multiple-edit-drawer-content-table');

export type MultipleEditDrawerContentTableProps<RawObject extends {} = {}> = Readonly<{
  data: RawObject[];
  isSortable?: boolean;
  addCheckbox?: boolean;
  addToggle?: boolean;
  disableAllToggles?: boolean;
  shouldDisableRowToggle?: (row: RawObject) => boolean;
  getToggleTooltip?: (row: RawObject) => string | undefined;
  toggleColumnHeaderText?: string;
  columns: Column<RawObject>[];
  initialState?: Partial<TableState<RawObject>>;
  listenSelectedRows?: (selectedRows: Record<IdType<RawObject>, boolean>) => void;
  getRowId?: (originalRow: RawObject, relativeIndex: number) => string;
}>;

export default function MultipleEditDrawerContentTable<RawObject extends {} = {}>({
  data,
  columns,
  isSortable,
  addCheckbox,
  addToggle,
  disableAllToggles,
  shouldDisableRowToggle,
  getToggleTooltip,
  toggleColumnHeaderText,
  initialState,
  listenSelectedRows,
  getRowId,
}: MultipleEditDrawerContentTableProps<RawObject>): JSX.Element {
  return (
    <div className={block()}>
      <CommonTable
        body={data}
        headers={columns}
        isSortable={isSortable}
        addCheckbox={addCheckbox}
        addToggle={addToggle}
        disableAllToggles={disableAllToggles}
        shouldDisableRowToggle={shouldDisableRowToggle}
        getToggleTooltip={getToggleTooltip}
        toggleColumnHeaderText={toggleColumnHeaderText}
        initialState={initialState}
        listenSelectedRows={listenSelectedRows}
        getRowId={getRowId}
      />
    </div>
  );
}
